module.exports = __webpack_public_path__ + "img/Диплом мединститут.b743b81d.jpg";